import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";
import { http } from "../../../../../services/HttpService";
import { uiNotification } from "../../../../../services/UINotificationService";

export const useSplitTime = (detailId) => {
  return useMutation({
    mutationFn: (dto) =>
      http.post(HTTP_ENDPOINTS.splitTimeTracking(detailId), dto),

    onSuccess: () => {
      uiNotification.success("Time split successfully");
    },

    onError: (error) => {
      const defaultMessage = "Failed to split time tracking.";
      const message = error?.response?.data?.message || defaultMessage;

      uiNotification.error(message);
    },
  });
};
